import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { catchError, map, Observable, of, take } from 'rxjs';

import { ProvisioningRepository } from '@efficiently/client-api-provisioning';
import { GraphQLClient } from '@efficiently/client-core-graphql';

import { CAPTURE_REGISTRATION } from '../queries/capture-registration';

// BMS / Implemented in EFF-13557
@Injectable()
export class ProvisioningGqlRepository extends ProvisioningRepository {
	private readonly apollo = inject(Apollo);

	public override captureRegistration(): Observable<void> {
		return this.apollo
			.mutate({
				mutation: CAPTURE_REGISTRATION,
				context: { client: GraphQLClient.Identity },
			})
			.pipe(
				// The mutation returns a success boolean, but `ProvisioningRepository.captureRegistration`
				// declares `void` and no caller inspects it — discard it explicitly rather than widening
				// the contract in this sweep.
				map(() => undefined),
				take(1),
				catchError(error => {
					console.error('Error capturing registration:', error);
					return of(null);
				}),
			);
	}
}
